module.exports = __webpack_public_path__ + "img/clogo.ab6bff85.png";